import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsNumber } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadWebMerchantThemeSpacingDto {
}
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "none", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "px", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-px", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "xxs", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-xxs", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "xs", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-xs", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "s", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-s", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "m", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-m", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "l", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-l", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "xl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-xl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "xxl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-xxl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "xxxl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-xxxl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 1, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-1", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 2, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-2", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 3, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-3", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 4, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-4", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 5, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-5", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 6, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-6", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 7, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-7", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 8, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-8", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 9, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-9", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 10, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, "-10", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 12, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 16, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 20, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 24, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 32, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 40, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 48, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 56, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 64, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 72, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 80, void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    __metadata("design:type", Number)
], ReadWebMerchantThemeSpacingDto.prototype, 96, void 0);
//# sourceMappingURL=ReadWebMerchantThemeSpacingDto.js.map